import { ReactComponent as AddCircle } from './svg/add-circle.svg';
import { ReactComponent as BinLogo } from './svg/bin.svg';
import { ReactComponent as BlueArrowUpLogo } from './svg/blue-arrow-up.svg';
import { ReactComponent as BlueArrowLogo } from './svg/blue-arrow.svg';
import { ReactComponent as BlueCrossDark } from './svg/blue-cross-dark.svg';
import { ReactComponent as BlueArrowDownLogo } from './svg/bluearrow-down.svg';
import { ReactComponent as Bridge } from './svg/bridge.svg';
import { ReactComponent as BuyCryptoLogo } from './svg/buy-crypto.svg';
import { ReactComponent as Calendar } from './svg/calendar.svg';
import { ReactComponent as Camera } from './svg/camera.svg';
import { ReactComponent as RedCloseCircleLogo } from './svg/close-circle.svg';
import { ReactComponent as Comment } from './svg/comment.svg';
import { ReactComponent as Compare } from './svg/compare.svg';
import { ReactComponent as Completed } from './svg/completed.svg';
import { ReactComponent as Computer } from './svg/computer.svg';
import { ReactComponent as DropdownCrossDark } from './svg/cross-dark.svg';
import { ReactComponent as DropdownCross } from './svg/cross-light.svg';
import { ReactComponent as Cross } from './svg/cross.svg';
import { ReactComponent as Cup } from './svg/cup.svg';
import { ReactComponent as Device } from './svg/device.svg';
import { ReactComponent as Dislike } from './svg/dislike.svg';
import { ReactComponent as DislikeDark } from './svg/dislike_dark.svg';
import { ReactComponent as dropdownArrowDark } from './svg/dropdown-arrow-dark.svg';
import { ReactComponent as dropdownArrow } from './svg/dropdown-arrow.svg';
import { ReactComponent as DropdownDownArrowDark } from './svg/dropdown-down-arrow-dark.svg';
import { ReactComponent as DropdownDownArrow } from './svg/dropdown-down-arrow.svg';
import { ReactComponent as EditDark } from './svg/edit-dark.svg';
import { ReactComponent as EditLogo } from './svg/edit.svg';
import { ReactComponent as Funny } from './svg/funny.svg';
import { ReactComponent as GreenHeartDark } from './svg/green-heart-dark.svg';
import { ReactComponent as GreenHeart } from './svg/green-heart.svg';
import { ReactComponent as GreenLike } from './svg/green-like.svg';
import { ReactComponent as Helpful } from './svg/helpful.svg';
import { ReactComponent as humanEdSoon } from './svg/humaned-soon.svg';
import { ReactComponent as InfoLogo } from './svg/info.svg';
import { ReactComponent as LeftArrow } from './svg/left-arrow.svg';
import { ReactComponent as Like } from './svg/like.svg';
import { ReactComponent as LikeDark } from './svg/like_dark.svg';
import { ReactComponent as LockDark } from './svg/lock-dark.svg';
import { ReactComponent as Lock } from './svg/lock.svg';
import { ReactComponent as LogoutDark } from './svg/logout-dark.svg';
import { ReactComponent as Logout } from './svg/logout.svg';
import { ReactComponent as MercleWhite } from './svg/mercle-white.svg';
import { ReactComponent as MercleLogo } from './svg/mercle_black.svg';
import { ReactComponent as MercleLogoMobileDark } from './svg/mercle_logo_mobile.svg';
import { ReactComponent as MercleLogoMobile } from './svg/mercle_logo_mobile_dark.svg';
import { ReactComponent as MercleWhiteLogo } from './svg/mercle_white.svg';
import { ReactComponent as Moon } from './svg/moon-light.svg';
import { ReactComponent as MoreElementLogo } from './svg/more-elements.svg';
import { ReactComponent as OniontakesDark } from './svg/oniontakes-mobile-dark.svg';
import { ReactComponent as Oniontakes } from './svg/oniontakes-mobile.svg';
import { ReactComponent as OpposeCrossDark } from './svg/oppose-cross-dark.svg';
import { ReactComponent as OpposeCross } from './svg/oppose_cross.svg';
import { ReactComponent as Pending } from './svg/pending.svg';
import { ReactComponent as PowerHover } from './svg/power-hover.svg';
import { ReactComponent as Power } from './svg/power.svg';
import { ReactComponent as QuestionLight } from './svg/question-light.svg';
import { ReactComponent as RedCrossDark } from './svg/red-cross-dark.svg';
import { ReactComponent as RedCross } from './svg/red-cross.svg';
import { ReactComponent as RedDislike } from './svg/red-dislike.svg';
import { ReactComponent as RequestDark } from './svg/request-project-dark.svg';
import { ReactComponent as Request } from './svg/request.svg';
import { ReactComponent as PendingReview } from './svg/review-pending.svg';
import { ReactComponent as SearchLogo, ReactComponent as SearchLogoLight } from './svg/search.svg';
import { ReactComponent as ShowMore } from './svg/show-more.svg';
import { ReactComponent as ShowMoreDark } from './svg/showmore-dark.svg';
import { ReactComponent as Skip } from './svg/skip.svg';
import { ReactComponent as SortAsc } from './svg/sort-asc.svg';
import { ReactComponent as SortDesc } from './svg/sort-desc.svg';
import { ReactComponent as SortLogo } from './svg/sort.svg';
import { ReactComponent as Stake } from './svg/stake.svg';
import { ReactComponent as SubmissionRequired } from './svg/submission-required.svg';
import { ReactComponent as Sun } from './svg/sun-dark.svg';
import { ReactComponent as SuperStatsBlack } from './svg/superstats-black.svg';
import { ReactComponent as SuperTakeYellow } from './svg/supertake-yellow.svg';
import { ReactComponent as SupportDark } from './svg/support-dark.svg';
import { ReactComponent as SupportHeartDark } from './svg/support-heart-dark.svg';
import { ReactComponent as Support } from './svg/support.svg';
import { ReactComponent as SupportHeart } from './svg/support_heart.svg';
import { ReactComponent as Swap } from './svg/swap.svg';
import { ReactComponent as GreenTickLogo } from './svg/tick-circle.svg';
import { ReactComponent as Total } from './svg/total.svg';
import { ReactComponent as TwitterDarkLogo } from './svg/twitter-dark.svg';
import { ReactComponent as TwitterLightLogo } from './svg/twitter-light.svg';
import { ReactComponent as TwitterLogo } from './svg/twitter.svg';
import { ReactComponent as Upload } from './svg/upload.svg';
import { ReactComponent as VerticleLine } from './svg/vertical-line.svg';
import { ReactComponent as Mute } from './svg/volume-high.svg';
import { ReactComponent as Unmute } from './svg/volume-slash.svg';
import { ReactComponent as VotersDark } from './svg/voters-dark.svg';
import { ReactComponent as Voters } from './svg/voters.svg';
import { ReactComponent as Wallet } from './svg/wallet.svg';
const Icons = {
  dark: {
    twitter: TwitterDarkLogo,
    questionLogo: QuestionLight,
    edit: EditDark,
    voters: VotersDark,
    themeLogo: Sun,
    mercleLogoMobile: MercleLogoMobile,
    search: SearchLogo,
    mercle: MercleWhiteLogo,
    sort: SortLogo,
    supportHeart: SupportHeartDark,
    opposeCross: OpposeCrossDark,
    info: InfoLogo,
    oniontakes: OniontakesDark,
    moreElement: MoreElementLogo,
    buyCrypto: BuyCryptoLogo,
    blueArrow: BlueArrowLogo,
    twitterLogo: TwitterLogo,
    verticalLine: VerticleLine,
    cup: Cup,
    addCircle: AddCircle,
    blueArrowUp: BlueArrowUpLogo,
    blueArrowDown: BlueArrowDownLogo,
    binLogo: BinLogo,
    greenTick: GreenTickLogo,
    redCloseCircle: RedCloseCircleLogo,
    unmute: Unmute,
    mute: Mute,
    calendar: Calendar,
    compare: Compare,
    computer: Computer,
    camera: Camera,
    mercleWhite: MercleWhite,
    sort_asc: SortAsc,
    sort_desc: SortDesc,
    power: Power,
    powerHover: PowerHover,
    swap: Swap,
    bridge: Bridge,
    stake: Stake,
    humanEdSoon: humanEdSoon,
    wallet: Wallet,
    device: Device,
    request: RequestDark,
    total: Total,
    logout: LogoutDark,
    support: SupportDark,
    skip: Skip,
    completed: Completed,
    upload: Upload,
    reviewPending: PendingReview,
    submissionRequired: SubmissionRequired,
    cross: BlueCrossDark,
    leftArrow: LeftArrow,
    pending: Pending,
    lock: LockDark,
    like: LikeDark,
    dislike: DislikeDark,
    funny: Funny,
    helpful: Helpful,
    greenLike: GreenLike,
    redDislike: RedDislike,
    showMore: ShowMoreDark,
    comment: Comment,
    supertakeYellow: SuperTakeYellow,
    superStatsBlack: SuperStatsBlack,
    dropdownArrow: dropdownArrowDark,
    dropdownCross: DropdownCrossDark,
    greenHeart: GreenHeartDark,
    redCross: RedCrossDark,
    dropdownDownArrow: DropdownDownArrowDark,
  },
  light: {
    twitter: TwitterLightLogo,
    voters: Voters,
    edit: EditLogo,
    questionLogo: QuestionLight,
    themeLogo: Moon,
    search: SearchLogoLight,
    mercle: MercleLogo,
    sort: SortLogo,
    info: InfoLogo,
    supportHeart: SupportHeart,
    opposeCross: OpposeCross,
    mercleLogoMobile: MercleLogoMobileDark,
    oniontakes: Oniontakes,
    moreElement: MoreElementLogo,
    buyCrypto: BuyCryptoLogo,
    blueArrow: BlueArrowLogo,
    twitterLogo: TwitterLogo,
    verticalLine: VerticleLine,
    cup: Cup,
    addCircle: AddCircle,
    blueArrowUp: BlueArrowUpLogo,
    blueArrowDown: BlueArrowDownLogo,
    binLogo: BinLogo,
    greenTick: GreenTickLogo,
    redCloseCircle: RedCloseCircleLogo,
    unmute: Unmute,
    mute: Mute,
    calendar: Calendar,
    compare: Compare,
    computer: Computer,
    camera: Camera,
    mercleWhite: MercleWhite,
    sort_asc: SortAsc,
    sort_desc: SortDesc,
    power: Power,
    powerHover: PowerHover,
    swap: Swap,
    bridge: Bridge,
    stake: Stake,
    humanEdSoon: humanEdSoon,
    wallet: Wallet,
    device: Device,
    request: Request,
    total: Total,
    logout: Logout,
    support: Support,
    skip: Skip,
    completed: Completed,
    upload: Upload,
    reviewPending: PendingReview,
    submissionRequired: SubmissionRequired,
    cross: Cross,
    leftArrow: LeftArrow,
    pending: Pending,
    lock: Lock,
    like: Like,
    dislike: Dislike,
    funny: Funny,
    helpful: Helpful,
    greenLike: GreenLike,
    redDislike: RedDislike,
    showMore: ShowMore,
    comment: Comment,
    supertakeYellow: SuperTakeYellow,
    superStatsBlack: SuperStatsBlack,
    dropdownArrow: dropdownArrow,
    dropdownCross: DropdownCross,
    greenHeart: GreenHeart,
    redCross: RedCross,
    dropdownDownArrow: DropdownDownArrow,
  },
};
export default Icons;
